"use strict";
/**
 * AlignmentLoadingOverlay
 *
 * Aspect-ratio placeholder with a centered Spinner shown while an
 * alignment fetch is in flight.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignmentLoadingOverlay = void 0;
var react_1 = __importDefault(require("react"));
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var AlignmentLoadingOverlayComponent = function () { return (react_1.default.createElement("div", { className: "ws-alignment-loading-wrapper" },
    react_1.default.createElement("div", { className: "ws-alignment-loading-overlay" },
        react_1.default.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.large, label: "Loading visualization..." })))); };
var AlignmentLoadingOverlay = react_1.default.memo(AlignmentLoadingOverlayComponent);
exports.AlignmentLoadingOverlay = AlignmentLoadingOverlay;
AlignmentLoadingOverlay.displayName = "AlignmentLoadingOverlay";
